import { jsx } from "react/jsx-runtime";
import { Box } from "braid-design-system";
import { height } from "./TextSkeleton.css.mjs";
const TextSkeleton = ({
  height: height$1 = "small",
  width = "70%"
}) => /* @__PURE__ */ jsx(
  Box,
  {
    display: "flex",
    component: "span",
    background: "neutralLight",
    borderRadius: "standard",
    className: height[height$1],
    style: {
      width
    }
  }
);
export {
  TextSkeleton
};
